import { css } from 'styled-components';
import { useBreakpoint } from './BreakpointProvider.js';

const getResponsiveSizePX = (size)=>{
    switch(size){
        case "mobile":
            return 768;
        case "tablet":
            return 1200;
        case "desktop":
        default:
            return 0;
    }
};
const CSSResponsiveQuery = (responsiveSize)=>(responsiveCSS)=>{
        return css`
    @media screen and (max-width: ${getResponsiveSizePX(responsiveSize)}px) {
      ${responsiveCSS}
    }
  `;
    };
const CSSGenerateResponsive = (responsiveValues)=>(CSSGenerate)=>{
        // ['mobile', 'tablet', 'desktop']
        const responsiveCSS = css`
      ${!!responsiveValues[2] && CSSGenerate(responsiveValues[2])}
      ${!!responsiveValues[1] && CSSResponsiveQuery("tablet")(CSSGenerate(responsiveValues[1]))}
      ${!!responsiveValues[0] && CSSResponsiveQuery("mobile")(CSSGenerate(responsiveValues[0]))}
    `;
        return responsiveCSS;
    };
const normalizeResponsiveProps = (responsiveProps)=>{
    // No responsive props, just passthrough
    if (!Array.isArray(responsiveProps)) {
        return [
            null,
            null,
            responsiveProps
        ];
    }
    // ['mobile', 'tablet']
    if (responsiveProps.length === 2) {
        return [
            responsiveProps[0],
            responsiveProps[1],
            null
        ];
    }
    // ['mobile', 'tablet', 'desktop']
    if (responsiveProps.length === 3) {
        return [
            responsiveProps[0],
            responsiveProps[1],
            responsiveProps[2]
        ];
    }
    return [
        null,
        null,
        null
    ];
};
const getResponsiveProps = (responsiveProps)=>(CSSGenerate)=>{
        const normalizedProps = normalizeResponsiveProps(responsiveProps);
        return CSSGenerateResponsive([
            normalizedProps[0],
            normalizedProps[1],
            normalizedProps[2]
        ])(CSSGenerate);
    };
/**
 * Get the normalized responsive prop values.
 *
 * Will accept the different acceptable responsive prop types and return consistent `['mobile', 'tablet', 'desktop']`
 * responsive value array.
 */ const useResponsiveProps = (responsiveProps)=>{
    return normalizeResponsiveProps(responsiveProps);
};
const useActiveResponsiveProp = (responsiveProps)=>{
    const breakpoint = useBreakpoint();
    const normalizedResponsiveProps = useResponsiveProps(responsiveProps);
    const [mobile, tablet, desktop] = normalizedResponsiveProps;
    if (breakpoint === "mobile") {
        return mobile;
    }
    if (breakpoint === "tablet") {
        return tablet;
    }
    return desktop;
};

export { getResponsiveProps, getResponsiveSizePX, normalizeResponsiveProps, useActiveResponsiveProp, useResponsiveProps };
